<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is xHamster Downloader?</h3>
            <p>
                xHamster Downloader is a free tool that lets you download videos from xHamster for offline viewing. Save videos in high quality to watch later without an internet connection.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does xHamster Downloader work?</h3>
            <p>
                The xHamster video downloader works through a Chrome browser extension. After installing the extension, simply paste the xHamster video URL into the downloader, and it will extract the video file for you to download.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Is it safe to use xHamster Downloader?</h3>
            <p>
                Yes, our xHamster Downloader is safe to use. The Chrome extension operates entirely in your browser and doesn't require any software installation on your computer. Your downloads remain private.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">Can I download xHamster videos in HD quality?</h3>
            <p>
                Yes, you can download xHamster videos in their original quality, including HD and Full HD resolutions when available. The downloader preserves the video quality as uploaded.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
